import { OnDemandProgrammes } from './OnDemandProgrammes';
import { RollingProgrammes } from './RollingProgrammes';
import { SequentialProgrammes } from './SequentialProgrammes';
export { OnDemandProgrammes } from './OnDemandProgrammes';
export { RollingProgrammes } from './RollingProgrammes';
export { SequentialProgrammes } from './SequentialProgrammes';
export const ProgrammeTree = {
    SequentialProgrammes: { treeFC: SequentialProgrammes },
    RollingProgrammes: { treeFC: RollingProgrammes },
    OnDemandProgrammes: { treeFC: OnDemandProgrammes },
};
